export const PROFILE_OPTIONAL_COLUMNS = [
    'height',
    'gender',
    'dob',
    'consent',
    'checkin_preferences',
    'discovery_state',
    'profile_picture',
    'connected_at',
] as const;

export type ProfileOptionalColumn = (typeof PROFILE_OPTIONAL_COLUMNS)[number];

const MISSING_COLUMN_PATTERNS = [
    /column\s+"([^"]+)"\s+of\s+relation\s+"profiles"\s+does not exist/i,
    /could not find the ['"]([^'"]+)['"] column of ['"]profiles['"]/i,
    /could not find the column ['"]([^'"]+)['"] of ['"]profiles['"]/i,
] as const;

export function extractMissingProfileColumn(error: unknown): ProfileOptionalColumn | null {
    const errorObj = typeof error === 'object' && error ? (error as Record<string, unknown>) : {};
    const text = [
        String(errorObj.message ?? ''),
        String(errorObj.details ?? ''),
        String(errorObj.hint ?? ''),
    ].join(' ');

    for (const pattern of MISSING_COLUMN_PATTERNS) {
        const match = text.match(pattern);
        if (!match) continue;

        const candidate = match[1] as ProfileOptionalColumn;
        if (PROFILE_OPTIONAL_COLUMNS.includes(candidate)) {
            return candidate;
        }
    }

    return null;
}
